/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryMethodUpdateRequest } from '../../models/delivery-method-update-request';

export interface UpdateDeliveryMethod$Params {
  deliveryMethodId: string;
      body: DeliveryMethodUpdateRequest
}

export function updateDeliveryMethod(http: HttpClient, rootUrl: string, params: UpdateDeliveryMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateDeliveryMethod.PATH, 'put');
  if (params) {
    rb.path('deliveryMethodId', params.deliveryMethodId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateDeliveryMethod.PATH = '/delivery/methods/{deliveryMethodId}';
